<template>
  <v-card class="mt-5">
    <v-card-title>
      <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
        :headers="headers"
        :items="registros"
        :search="search"
    ></v-data-table>
  </v-card>


</template>

<script>
import { defineComponent}  from 'vue';
import Armablanca from "@/services/Armablanca";
import { VDataTable } from 'vuetify/labs/VDataTable'
export default defineComponent({
  name: 'AdminPage',
  components: {
    VDataTable
  },
  data(){
    var registros;
    const armablanca= new Armablanca();
    return {
      registros,
      armablanca,
      search:'',
      headers: [
        {
          align: 'start',
          key: 'name',
          sortable: false,

        },
        { key: 'codigo_armab', title: 'ID' },
        { key: 'descripcion', title: 'Nombre' },
        { key: 'modelo', title: 'Modelo ' },
        { key: 'pais_origen', title: 'Origen' },
      ],

    }
  },
  methods:{


  },

  async mounted(){
    this.registros=await this.armablanca.index();
  }
});
</script>